import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useI18n } from "@/locales/i18n-provider";

export function SettingsDiscardDialog({
  open,
  pending = false,
  onCancel,
  onDiscard,
}: {
  open: boolean;
  pending?: boolean;
  onCancel: () => void;
  onDiscard: () => void;
}) {
  const { t } = useI18n();
  return (
    <AlertDialog
      open={open}
      onOpenChange={(next) => {
        if (!next) onCancel();
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t(pending ? "settings.common.saving" : "settings.common.unsaved.title")}</AlertDialogTitle>
          <AlertDialogDescription>{t(pending ? "settings.common.savingDescription" : "settings.common.unsaved.description")}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            onClick={(event) => {
              event.preventDefault();
              onCancel();
            }}
          >
            {t("settings.common.unsaved.keepEditing")}
          </AlertDialogCancel>
          {!pending ? (
            <AlertDialogAction
              variant="destructive"
              onClick={(event) => {
                event.preventDefault();
                onDiscard();
              }}
            >
              {t("settings.common.unsaved.discard")}
            </AlertDialogAction>
          ) : null}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
